import { Button } from '@vp/swan'
import { useOpenCallMeWidget } from '@vp/care-react-c2c'
import { useTranslation } from 'react-i18next'

interface Props {
  tenant: string
  lng: string
}
export const CallMeButton = (props: Props) => {
  const { tenant, lng } = props
  const { t } = useTranslation(tenant)
  const openCallMeWidgetFunc = useOpenCallMeWidget()

  return (
    <Button
      id="email_call_me_button_online"
      onClick={() => {
        openCallMeWidgetFunc()
      }}
      skin="primary"
      width="standard"
      size="standard"
      type="button"
      name="email_call_me_now"
      value="email_call_me_now"
    >
      {t(`${tenant}:email.buttons.email_phone_modal_c2c.title`, { lng })}
    </Button>
  )
}
